export default __webpack_public_path__ + "static/media/sbj-geography.3c8a4453.svg";